import { TailSpin } from 'react-loader-spinner'

export default function LoaderTailSpin() {

    return <TailSpin color="#00BFFF" height={80} width={80} />
}